/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export type API58706Item = {};
    
  



  export type API58706Req = {};



export interface API58706Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** Long  */
  data?: number[];
  /**   */
  exceptionMsg?: string;
  
};


// 58706 统计待办任务数，与标签分类顺序一致

export interface IUseGetAPI58706Return {
  /** 统计待办任务数，与标签分类顺序一致: 接口请求状态 */
  isAPI58706Loading: boolean;
  /** 统计待办任务数，与标签分类顺序一致: 接口请求返回数据 */
  dataAPI58706: API58706Res;
  /**  统计待办任务数，与标签分类顺序一致: 接口数据请求方法 */
  fetchAPI58706Data:  ( config?: YWRequestConfig) => Promise<API58706Res>;
  /** 统计待办任务数，与标签分类顺序一致: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI58706 = ():IUseGetAPI58706Return => {
  let isMount = true;
  const [isAPI58706Loading, setIsAPI58706Loading] = useState(false);
  const [dataAPI58706, setDataAPI58706] = useState<API58706Res>({} as API58706Res);
  const requestUrl = `${basePath}/team-work/workTask/getTaskCountForTag`;

  const fetchAPI58706Data = async ( config?: YWRequestConfig): Promise<API58706Res> => {
  
    if ( isMount ) {
      setIsAPI58706Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API58706Res>(`${basePath}/team-work/workTask/getTaskCountForTag`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI58706(res || {} as API58706Res);
        setIsAPI58706Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI58706Loading(false);
      }
      return false as unknown as API58706Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI58706Loading,
    dataAPI58706,
    fetchAPI58706Data,
    requestUrl,
  }
}

